module.exports = __webpack_public_path__ + "static/media/Hari.83c4add5.jpg";